import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/page404/page404.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { Role } from "./core/models/role";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      {
        path: "admin",
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.AdminViewOnly],
        },
        loadChildren: () =>
          import("./admin/admin.module").then((m) => m.AdminModule),
      },
      {
        path: "doctor",
        canActivate: [AuthGuard],
        data: {
          role: Role.Doctor,
        },
        loadChildren: () =>
          import("./doctor/doctor.module").then((m) => m.DoctorModule),
      },
      {
        path: "pharmacy",
        canActivate: [AuthGuard],
        data: {
          role: Role.Pharmacy,
        },
        loadChildren: () =>
          import("./pharmacy/pharmacy.module").then((m) => m.PharmacyModule),
      },
      {
        path: "nutritionist",
        canActivate: [AuthGuard],
        data: {
          role: Role.Nutritionist,
        },
        loadChildren: () =>
          import("./nutritionist/nutritionist.module").then(
            (m) => m.NutritionistModule
          ),
      },
      {
        path: "dealer",
        canActivate: [AuthGuard],
        data: {
          role: Role.Dealer,
        },
        loadChildren: () =>
          import("./dealer/dealer.module").then((m) => m.DealerModule),
      },
      {
        path: "distributor",
        canActivate: [AuthGuard],
        data: {
          role: Role.Distributor,
        },
        loadChildren: () =>
          import("./distributor/distributor.module").then(
            (m) => m.DistributorModule
          ),
      },
      {
        path: "audit",
        canActivate: [AuthGuard],
        data: {
          role: Role.Audit,
        },
        loadChildren: () =>
          import("./audit/audit.module").then((m) => m.AuditModule),
      },
      {
        path: "telSupport",
        canActivate: [AuthGuard],
        data: {
          role: Role.TelSupport,
        },
        loadChildren: () =>
          import("./tel-support/telsupport.module").then(
            (m) => m.TelSupportModule
          ),
      },
      {
        path: "deliver",
        canActivate: [AuthGuard],
        data: {
          role: Role.Packer,
        },
        loadChildren: () =>
          import("./packer/packer.module").then(
            (m) => m.PackerModule
          ),
      },
      {
        path: "patient",
        canActivate: [AuthGuard],
        data: {
          role: Role.Patient,
        },
        loadChildren: () =>
          import("./patient/patient.module").then((m) => m.PatientModule),
      },
      {
        path: "calendar",
        loadChildren: () =>
          import("./calendar/calendar.module").then((m) => m.CalendarsModule),
      },
    ],
  },
  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "rux",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
